import PropTypes from "prop-types";
import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

const getPolygonFromBounds = (bounds) => {
  const north = bounds.getNorthEast().lat();
  const south = bounds.getSouthWest().lat();
  const east = bounds.getNorthEast().lng();
  const west = bounds.getSouthWest().lng();

  return [
    {
      lat: north,
      lng: east,
    },
    {
      lat: north,
      lng: west,
    },
    {
      lat: south,
      lng: west,
    },
    {
      lat: south,
      lng: east,
    },
  ];
};

const SearchMapViewportManager = ({ listings, onClick, onUserDragMap }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const clickListener = map.addListener("click", onClick);
    const dragEndListener = map.addListener("dragend", () => {
      const bounds = map.getBounds();
      if (!bounds) {
        return;
      }

      onUserDragMap(getPolygonFromBounds(bounds));
    });

    // eslint-disable-next-line consistent-return
    return () => {
      clickListener.remove();
      dragEndListener.remove();
    };
  }, [map, onClick, onUserDragMap]);

  useEffect(() => {
    if (!map || !listings.length) {
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    let hasCoordinates = false;

    listings.forEach((listing) => {
      if (listing.lat == null || listing.lng == null) {
        return;
      }

      hasCoordinates = true;
      bounds.extend({ lat: listing.lat, lng: listing.lng });
    });

    if (!hasCoordinates) {
      return;
    }

    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
      const coordinateManipulator = 0.01;

      bounds.extend({
        lat: bounds.getNorthEast().lat() + coordinateManipulator,
        lng: bounds.getNorthEast().lng() + coordinateManipulator,
      });
      bounds.extend({
        lat: bounds.getSouthWest().lat() - coordinateManipulator,
        lng: bounds.getSouthWest().lng() - coordinateManipulator,
      });
    }

    map.fitBounds(bounds);
  }, [map, listings]);

  return null;
};

SearchMapViewportManager.propTypes = {
  listings: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  onUserDragMap: PropTypes.func.isRequired,
};

export default SearchMapViewportManager;
